import { ErrorDisplay } from '../error';

export interface UiErrorModel {
  message: string;
  id?: string;
  code?: string;
  retryBtnVisible?: boolean;
  assistanceBtnVisible?: boolean;
  displayMode?: ErrorDisplay;
}
